import * as React from "react";
import styled from "../../../styled/index";
import { FaTimes } from "react-icons/fa";
export const Box = styled("div") `
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  padding: 45px 30px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    max-width: 500px;
    margin: 0 auto;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    max-width: 420px;
    margin: 0 auto;
  }
`;
const Wrapper = styled("div") `
  display: flex;
  flex-wrap: wrap;
`;
const Thumbnail = styled("div") `
  position: relative;
  border-radius: 5px;
  border: 2px solid ${({ theme }) => theme.box.border};
  background: url(${({ url }) => url}) no-repeat center center;
  background-size: cover;
  width: 60px;
  height: 60px;
  margin-right: 10px;
`;
const CloseIcon = styled("div") `
  position: absolute;
  right: -12px;
  top: -12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary_text};
  cursor: pointer;
`;
export const ImageUploadThumbnails = (props) => (React.createElement(Wrapper, null, props.images.map((image, i) => (React.createElement(Thumbnail, { key: i, url: image },
    React.createElement(CloseIcon, { onClick: () => props.onRemove(i) },
        React.createElement(FaTimes, null)))))));
//# sourceMappingURL=index.js.map